import URI from 'urijs'
import linkResolver from './linkResolver'
import parsePageData from './parsePageData'

export const getRelativeUrl = url => {
  const uri = URI(url)

  if (uri.domain() !== 'iamgia.com') {
    return url
  }
  return uri.resource()
}

export const getHandle = domain => domain.split('.')[0]

export { linkResolver, parsePageData }
